export * from "./lib/prognose.module";
